// @ts-nocheck
import CarePlanDocumentModal from './CarePlanDocumentModal'
import DocumentModal from './DocumentModal'
import AddResidentModal from './AddResidentModal'
import AddShiftModal from './AddShiftModal'
import AddTeamMemberModal from './AddTeamMemberModal'
import AddCarePlanModal from './AddCarePlanModal'
import AddZoneModal from './AddZoneModal'
import EditZoneModal from './EditZoneModal'
import EditResidentZoneModal from './EditResidentZoneModal'
import EditShiftModal from './EditShiftModal'
import EmarRoundTimingModal from './EmarRoundTimingModal'
import FamilyPortalSetupModal from './FamilyPortalSetupModal'
import TaskCreateModal from './TaskCreateModal'
import TaskEditModal from './TaskEditModal'
import CreateRiskAssessment from './CreateRiskAssessment'
import AddMedicationModal from './AddMedicationModal'
import EditMedicationModal from './EditMedicationModal'
import AddLogModal from './AddLogModal'
import SwitchHomeModal from './SwitchHomeModal'
import InviteFamilyModal from './InviteFamilyModal'
import AddEmarMedicationModal from './AddEmarMedicationModal'
import OnboardEmarModal from './OnboardEmarModal'
import EmarDiscontinueMedModal from './EmarDiscontinueMedModal'
import EmarMedicationQuantityModal from './EmarMedicationQuantityModal'
import StockLogModal from './StockLogModal'

const MountedModals = ({ router }) => (
  <div>
    <AddCarePlanModal router={router} />
    <AddMedicationModal router={router} />
    <AddResidentModal router={router} />
    <SwitchHomeModal router={router} />
    <AddTeamMemberModal router={router} />
    <AddShiftModal />
    <AddZoneModal />
    <CreateRiskAssessment router={router} />
    <CarePlanDocumentModal />
    <DocumentModal />
    <EditMedicationModal />
    <EditResidentZoneModal />
    <EditShiftModal />
    <EditZoneModal />
    <FamilyPortalSetupModal />
    <TaskEditModal />
    <TaskCreateModal />
    <AddLogModal />
    <InviteFamilyModal />
    <AddEmarMedicationModal router={router} />
    <OnboardEmarModal router={router} />
    <EmarRoundTimingModal />
    <EmarDiscontinueMedModal />
    <EmarMedicationQuantityModal />
    <StockLogModal />
  </div>
)

export default MountedModals
